module.exports = __webpack_public_path__ + "img/map_Z2.6.C.05.041acb2c.svg";